import { TFunction } from '@gem/modules/i18n';

import { getTtlPeriodText } from 'APP/main/ChatView/ChatAutoCleanupSettings/ChatAutoCleanupSettings.utils';

import {
  TSystemMessageTextHandler,
  ISystemMessageText,
  ISystemMessageTextPresenter,
} from '../useSystemMessageText.types';

export const chatTtlChangedHandler: TSystemMessageTextHandler = (
  presenter: ISystemMessageTextPresenter,
  t: TFunction
): ISystemMessageText => {
  const text = t('chat_auto_cleanup_changed_system', {
    0: `<span class="system-message-title">${presenter.initiatorDisplayName}</span>`,
    1: getTtlPeriodText(presenter.payload.periodMs),
    interpolation: { escapeValue: false },
  });

  return { html: text };
};
